<script>
    import {getObjects, getObj, saveObj, deleteObj} from '../lib/data.js';
    import {notifier} from '@beyonk/svelte-notifications';
    import Loader from '../Utilities/Loader.svelte';

    import Field from '../Forms/Field.svelte';
    import Editor from '../Forms/Editor.svelte';

    let editor;

    let snippets;

    let selected;

    function addSnippet(e) {
        selected = {name: "New Snippet", snippet: ""}
    }

    async function loadSnippet() {
        let snippet_id = this.dataset.id;

        selected = await getObj("snippet", snippet_id);
    }

    async function loadSnippets() {
        snippets = await getObjects("snippet", {fields: ['id', 'name']});
    }

    function focusEditor() {
        if(editor) {
            editor.focus()
        }
    }

    async function saveSnippet() {
        selected  = await saveObj("snippet", selected);

        notifier.success("Snippet Saved!")

        loadSnippets();
    }

    async function deleteSnippet() {
        if (confirm("Are you sure you want to delete snippet?")) {
            deleteObj("snippet", selected);
            selected = undefined;
            notifier.success("Snippet Deleted!")
            loadSnippets()
        }
    }

    loadSnippets();
</script>

<style>
    #toolbarTop {
        width: 8.5in;
        margin: auto;
    }
</style>

<Loader obj={snippets}>
    <h1 class="title">
        Snippets
        {#if selected}
            <div class="buttons is-pulled-right">
                {#if selected.id}
                    <button class="button is-danger" on:click={deleteSnippet}>Delete</button>
                {/if}
                <button class="is-success button" on:click={saveSnippet}>Save</button>
            </div>
        {/if}
    </h1>

    <div class="columns">
        <div class="column is-2">
            <div class="menu">
                <p class="menu-label">Snippets</p>
                <ul class="menu-list">
                    {#each snippets as snippet, idx}
                        <li><span class="link" data-id={snippet.id} on:click={loadSnippet}>{snippet.name}</span></li>
                    {/each}
                </ul>
                <p class="menu-label">Actions</p>
                <ul class="menu-list">
                    <li><span class="link" on:click={addSnippet}>New Snippet</span></li>
                </ul>
            </div>
        </div>
        <div class="column">
            {#if selected}
                <Field label="Name" bind:value={selected.name} placeholder="Snippet Name" name="name" required=1 />
                <div id="toolbarTop"></div>
                <div class="preview" on:click={focusEditor}>
                    <Editor bind:content={selected.snippet} bind:this={editor} />
                </div>
            {/if}
        </div>
    </div>
</Loader>